import DeploymentDetail from './DeploymentDetail.container'
export default DeploymentDetail
